import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'processing-label',
    templateUrl: './processing-label.component.html',
    styleUrls: ['./processing-label.component.scss'],
    standalone: false
})
export class ProcessingLabelComponent implements OnInit {
  @Input() withText: boolean = true;
  @Input() text = 'translate.general.processing';

  constructor() {}

  ngOnInit(): void {}
}
